import Task from '../../../types/Task';
import { SpaceLabel } from '../../../types/TaskLabel';

/** How many of the selected tasks already carry this label. */
const taskCountWithLabel = (label: SpaceLabel, selectedTasks: Task[]): number =>
  selectedTasks.filter((task) => task.TaskLabels?.some((taskLabel) => taskLabel.labelId === label.id)).length;

/**
 * Order the batch label list by how much of the selection already has each
 * label: on every selected task first, then on some of them, then the rest.
 * Matches the checkbox states the rows render (checked → indeterminate → empty),
 * so the labels you can act on sit at the top instead of being scattered
 * through the full workspace list. #2757
 *
 * Sort is stable, so labels keep their existing relative order within a bucket.
 */
export function sortLabelsBySelection(labels: SpaceLabel[], selectedTasks: Task[]): SpaceLabel[] {
  const rank = (label: SpaceLabel): number => {
    const count = taskCountWithLabel(label, selectedTasks);
    if (selectedTasks.length > 0 && count === selectedTasks.length) return 0;
    if (count > 0) return 1;
    return 2;
  };

  return [...labels].sort((a, b) => rank(a) - rank(b));
}
